// extracted by mini-css-extract-plugin
export default {"ArticleTill":"ArticleTill_ArticleTill__hbmm3","list":"ArticleTill_list__WANtY"};